import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';

// Layouts
import MainLayout from '@/features/pages/components/layout';
import Menu from '@/shared/components/MenuBar';
import CollectionMenu from '@/features/collections/components/CollectionMenu';
import CollectionDetailLayout from '@/features/collections/components/CollectionDetailLayout';

// Lazy-loaded components
const HomePage = lazy(() => import('@/pages/HomePage'));
const DocumentPage = lazy(() => import('@/features/pages/components/DocumentPage'));
const SharedPage = lazy(() => import('@/pages/SharedPage'));
const PrivacyPolicy = lazy(() => import('@/pages/Privacy'));
const CollectionsPage = lazy(() => import('@/features/collections/components/CollectionsPage'));
const CollectionDetailPage = lazy(
  () => import('@/features/collections/components/CollectionDetailPage')
);

// Loading component for Suspense
const PageLoader = () => null;

export default function MainDomainRoutes() {
  return (
    <Routes>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      {/* Routes with sidebar/menu layout */}
      <Route
        path="/"
        element={
          <MainLayout Menu={<Menu />}>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </MainLayout>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="page/:pageId" element={<DocumentPage />} />
      </Route>

      <Route
        path="/collections"
        element={
          <MainLayout Menu={<CollectionMenu />}>
            <Suspense fallback={<PageLoader />}>
              <CollectionsPage />
            </Suspense>
          </MainLayout>
        }
      />

      <Route
        path="/collection"
        element={
          <CollectionDetailLayout Menu={<Menu />}>
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </CollectionDetailLayout>
        }
      >
        <Route path=":collectionId" element={<CollectionDetailPage />} />
        <Route path=":collectionId/page/:pageId" element={<DocumentPage />} />
      </Route>

      {/* Only individual shared pages allowed on main domain */}
      <Route path="/shared/page/:pageId" element={<SharedPage />} />

      {/* Catch-all route for invalid paths */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
